
export default {
  props: {
    timer: {
      type: Number,
      default: 300,
    },
  },

  data: () => ({
    timeOut: null,
    counter: 0,
  }),

  methods: {
    handleClick() {
      this.counter += 1;
      clearTimeout(this.timeOut);

      this.timeOut = setTimeout(() => {
        this.$emit('click');
      }, this.timer);
    },
  },
};
